/** E.164: + then 8 to 15 digits. Spaces and dashes typed by people are removed first. */
export function normalisePhone(input: string): string | null {
  const compact = input.replace(/[\s-]/g, '');
  return /^\+[1-9]\d{7,14}$/.test(compact) ? compact : null;
}

/** Country codes offered beside the number, Singapore first. */
export const COUNTRY_CODES = ['+65', '+60', '+62', '+63', '+66', '+84', '+852', '+86', '+886', '+91', '+81', '+82', '+61', '+44', '+1'];

/** A code from the list and the local number as typed; a number typed with its own + code wins. */
export function withCountryCode(code: string, local: string): string | null {
  const typed = local.trim();
  return normalisePhone(typed.startsWith('+') ? typed : `${code}${typed.replace(/^0+/, '')}`);
}
